@if (storeService.getScreenType() === ScreenType.UTWORZ_PRZESYLKE) {
<div class="fdx-o-grid fdx-o-grid--max-width">
  <app-page-header [title]="'Wprowadź dane Twojej przesyłki'">
    Wybierz typ i wprowadź parametry przesyłki, którą chcesz nadać.<br />
    Wybierz usługi dodatkowe i naciśnij DALEJ by przejść do kolejnego kroku.
  </app-page-header>

  <app-main-option-buttons-wrapper>
    <app-main-option-button
      class="fdx-o-grid__item--4 fdx-o-grid__item--3@medium"
      (click)="paczkaPaletaType = PaczkaPaletaType.NADAJ_PACZKE"
      [label]="'Nadaj paczkę'"
      [iconPathForActiveButton]="'assets/images/parcel_icon_white.png'"
      [iconPathForInActiveButton]="'assets/images/parcel_icon_grey.png'"
      [isActive]="
        paczkaPaletaType === PaczkaPaletaType.NADAJ_PACZKE
      "></app-main-option-button>
    <app-main-option-button
      class="fdx-o-grid__item--4 fdx-o-grid__item--3@medium"
      (click)="paczkaPaletaType = PaczkaPaletaType.NADAJ_PALETE"
      [label]="'Nadaj paletę'"
      [iconPathForActiveButton]="'assets/images/pallet_icon_white.png'"
      [iconPathForInActiveButton]="'assets/images/pallet_icon_grey.png'"
      [isActive]="
        paczkaPaletaType === PaczkaPaletaType.NADAJ_PALETE
      "></app-main-option-button>
  </app-main-option-buttons-wrapper>

  @if (paczkaPaletaType === PaczkaPaletaType.NADAJ_PACZKE) {
  <app-parcel-form></app-parcel-form>
  } @if (paczkaPaletaType === PaczkaPaletaType.NADAJ_PALETE) {
  <app-palett-form></app-palett-form>
  }
</div>
}

<app-delivery-options-page></app-delivery-options-page>
